import { useCallback } from 'react';
// @ts-expect-error Could not find a declaration file for module
import HubSpotLanguageSelect from 'ui-addon-i18n/components/HubSpotLanguageSelect';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EXPORT_EMAIL_KEY, EXPORT_FORMAT_KEY, EXPORT_LANGUAGE_KEY } from '../exportTypes';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import createFormField from 'ExportDialog/modal/formFields/FormField';
import EmailFieldAndNotificationHelpText from 'ExportDialog/modal/formFields/EmailFieldAndNotificationHelpText';
import FormatField from 'ExportDialog/modal/formFields/FormatField';
import getLang from 'academy-common-lib/utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
const LanguageField = ({
  onChange,
  value = getLang()
}) => {
  const handleLanguageChange = useCallback(({
    language: newLanguage
  }) => {
    onChange(newLanguage);
  }, [onChange]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.export.languageTip"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.export.languageHeader"
      })
    }),
    children: /*#__PURE__*/_jsx(HubSpotLanguageSelect, {
      onChange: handleLanguageChange,
      validLanguages: ['ja', 'pt-br', 'de', 'en', 'es', 'fr'],
      value: value
    })
  });
};
export const createExportLanguageFormField = (language = getLang()) => createFormField(LanguageField, EXPORT_LANGUAGE_KEY, language);
export const ExportEmailFormField = createFormField(EmailFieldAndNotificationHelpText, EXPORT_EMAIL_KEY);
export const ExportFormatFormField = createFormField(FormatField, EXPORT_FORMAT_KEY);